import { defineStore } from 'pinia'

const state = () => ({
  query: null,
})

const getters = {
}

const actions = {
  clear() {
    this.query = ''
  },
  cancel() {
    this.query = null
  },
}

export default defineStore({
  id: 'bcSearch',
  state,
  getters,
  actions
})